import { combineReducers } from "redux";
import cubeMgmtSlice from "store/cubeMgmt";
import layoutSlice from "store/layout";
import cubeGroupsSlice from "store/cubeGroups";
import staticReports from "./staticReportsReducer";
import staticReportsSnowflakeSlice from "store/staticReportsSnowflake";
import psoResultsSlice from "store/psoResults";
import stackReportDashboardSlice from "store/stackReportDashboard";
import map from "./mapReducer";
import comparerDshbSlice from "store/comparerDshb";
import instanceMgrSlice from "store/instanceManager";
import accountMgmtSlice from "store/accountMgmt";
import projectMgmtSlice from "store/projectMgmt";
import taskMgmtSlice from "store/taskMgmt";
import scenarioMgmtSlice from "store/scenarioMgmt";
import scenarioStatusSlice from "store/scenarioStatus";
import enelytixBillingSlice from "store/enelytixBilling";
import psoLogsSlice from "store/psoLogs";
import scenarioGroups from "store/scenarioGroups";
import tagsSlice from "store/tags";
import otiManager from "./otiReducer";
import probes from "store/probe";
import resourceAdequacySlice from "store/resourceAdequacy";
import dashboardViewerSlice from "../store/dashboardViewer/reducer";
import dashboardMgmtSlice from "store/dashboardMgmt";
import oneLineDiagramSlice from "store/oneLineDiagram";

const rootReducer = () =>
    combineReducers({
        cubeMgmtSlice,
        layoutSlice,
        cubeGroupsSlice,
        staticReports,
        staticReportsSnowflakeSlice,
        psoResultsSlice,
        stackReportDashboardSlice,
        map,
        comparerDshbSlice,
        instanceMgrSlice,
        accountMgmtSlice,
        projectMgmtSlice,
        taskMgmtSlice,
        scenarioMgmtSlice,
        scenarioStatusSlice,
        enelytixBillingSlice,
        psoLogsSlice,
        scenarioGroups,
        tagsSlice,
        probes,
        otiManager,
        resourceAdequacySlice,
        dashboardViewerSlice,
        dashboardMgmtSlice,
        oneLineDiagramSlice
    });

export default rootReducer;
